import type { PublicProfile } from '../../shared/types'

export type AdPayload = {
  headline?: string
  body?: string
  cta?: string
  demo?: boolean
}

/** In-feed sponsored card — same footprint as a profile card, never full-screen. */
export function AdCard({
  ad,
  onContinue,
  onUpgrade,
}: {
  ad: AdPayload
  onContinue: () => void
  onUpgrade: () => void
}) {
  return (
    <div className="discover-layout">
      <div className="discover-heading">
        <div>
          <span className="eyebrow">Sponsored</span>
          <h1>While you browse</h1>
        </div>
        <span className="free-pill">Ad</span>
      </div>

      <article className="profile-card ad-card" aria-label="Sponsored content">
        <div className="ad-card-inner">
          <span className="ad-card-badge">{ad.demo ? 'Sponsored · demo' : 'Sponsored'}</span>
          <h2>{ad.headline ?? 'Pairvelle Plus'}</h2>
          <p>{ad.body ?? 'Go ad-free and unlock advanced filters. Mutual matches always message free.'}</p>
          <p className="ad-card-note">Ads appear in your feed roughly every 15–25 profile decisions on the free plan.</p>
        </div>
      </article>

      <div className="profile-actions">
        <button aria-label="Skip ad" className="circle-action skip" onClick={onContinue}>
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="m6 6 12 12M18 6 6 18" />
          </svg>
        </button>
        <button className="message-action" onClick={onUpgrade}>
          {ad.cta ?? 'Go ad-free'}
        </button>
        <button aria-label="Continue" className="circle-action like" onClick={onContinue}>
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M5 12h14M13 5l6 7-6 7" />
          </svg>
        </button>
      </div>
    </div>
  )
}

/** Placeholder type when ad is inserted into feed logic */
export type FeedItem =
  | { kind: 'profile'; profile: PublicProfile }
  | { kind: 'ad'; ad: AdPayload }
